import PropTypes from "prop-types";

// material-ui
import { useDataPrivacy } from "../../../../../utils/dataPrivacy";
import {
    Box,
    Divider,
    Drawer,
    IconButton,
    Stack,
    Tooltip,
    useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// third-party
import { BrowserView, MobileView } from "react-device-detect";

// project imports
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useSelector } from "react-redux";
import config from "../../../../../../config";
import { RoleLevel } from "../../../../../../domain/entities/Role";
import { useAuth } from "../../../../../hooks/useAuth";
import OrganizationSelector from "../../../../pages/administrator/organizations/OrganizationSelector";
import LogoSection from "../LogoSection";
import MenuList from "./MenuList";
import MiniDrawerStyled from "./mini-drawer";
import "./sidebar-style.css";
//import { drawerWidth } from 'store/constant';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const leftDrawerOpened = useSelector((state) => state.session.menuVisible);
  const { user } = useAuth();
  // Hidden in Data Privacy Mode: it names the current district and lists the others.
  const dataPrivacy = useDataPrivacy();

  const drawer = (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Box sx={{ display: "flex", p: 2, mx: "auto" }}>
          <LogoSection />
        </Box>
      </Box>
      {user?.role?.level >= RoleLevel.SignatureRequestor && !dataPrivacy && (
        <Box className="organizationSelector-container" sx={{ pt: 2, px: 1 }}>
          <OrganizationSelector />
          <Divider sx={{ mt: 1, mx: 1 }} />
        </Box>
      )}
      <BrowserView>
        <Box
          component="div"
          className={`sidebar-scroll-area${leftDrawerOpened ? ' sidebar-expanded' : ''}`}
          sx={{
            height: !matchUpMd ? "calc(100vh - 20px)" : "calc(100vh - 88px)",
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingTop: leftDrawerOpened ? "26px" : "85px",
            paddingBottom: '60px',
            boxSizing: 'border-box',
          }}
        >
          <MenuList />
          {/* {process.env.REACT_APP_ENV === Environment.DEV && <MenuCard />}
          {process.env.REACT_APP_ENV === Environment.DEV && (
            <Stack direction="row" justifyContent="center" sx={{ mb: 2 }}>
              <Chip
                label={`${process.env.REACT_APP_VERSION} - ${process.env.REACT_APP_ENV}`}
                disabled
                chipcolor="secondary"
                size="small"
                sx={{ cursor: "pointer" }}
              />
            </Stack>
          )} */}
        </Box>
      </BrowserView>
      <MobileView>
        <Box sx={{ px: 2 }}>
          <MenuList />
        {/*   <MenuCard /> */}
          <Stack direction="row" justifyContent="center" sx={{ mb: 2 }}>
          {/*  <Chip
              label={process.env.REACT_APP_VERSION}
              disabled
              chipcolor="secondary"
              size="small"
              sx={{ cursor: "pointer" }}
            /> */}
          </Stack>
        </Box>
      </MobileView>
    </>
  );

  const toggleMenu = (
      <Box
      sx={{
        position: "fixed",
        bottom: 0,
        width: leftDrawerOpened ? config.drawerPurpleArrowWidth : "72px",
        backgroundColor: "#ffffff00",
        display: "flex",
        justifyContent: "flex-end",
        //borderTop: "solid 1px #e3e8ef",
        //boxShadow: 3,
      }}
    >
      <IconButton aria-label="menu" onClick={drawerToggle} color="secondary">
        {leftDrawerOpened ? (
          <Tooltip title="Show less">
            <KeyboardDoubleArrowLeftIcon />
          </Tooltip>
        ) : (
          <Tooltip title="Show more">
            <KeyboardDoubleArrowRightIcon />
          </Tooltip>
        )}
      </IconButton>
    </Box>
  );

  const container =
    window !== undefined ? () => window.document.body : undefined;

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { md: 0 },
        width: matchUpMd ? config.drawerWidth : "auto",
      }}
      aria-label="mailbox folders"
    >
      {leftDrawerOpened ? (
        <Drawer
          container={container}
          variant={matchUpMd ? "persistent" : "temporary"}
          anchor="left"
          open={drawerOpen}
          onClose={drawerToggle}
          sx={{
            "& .MuiDrawer-paper": {
              height: "calc(100vh - 20px)",
              width: config.drawerWidth,
              background: theme.palette.background.default,
              color: theme.palette.text.primary,
              borderRight: "none",
              [theme.breakpoints.up("md")]: {
                top: "88px",
              },
            },
          }}
          ModalProps={{ keepMounted: true }}
          color="inherit"
        >
          {drawer}
          {toggleMenu}
        </Drawer>
      ) : (
        // Collapsed icon rail: desktop only. Below md the hamburger opens the
        // temporary overlay instead, so the rail must not reappear on resize.
        <MiniDrawerStyled
          variant="permanent"
          open={drawerOpen}
          sx={{ display: { xs: "none", md: "block" } }}
        >
          {drawer}
          {toggleMenu}
        </MiniDrawerStyled>
      )}
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object,
};

export default Sidebar;
